import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

const styles = {
  lg: {
    margin: '20% auto',
    minHeight: '100px',
  },
  md: {
    margin: '10% auto',
    minHeight: '100px',
  },
  sm: {
    margin: '5% auto',
    minHeight: '100px',
  },
};

interface LoaderProps {
  size?: 'lg' | 'md' | 'sm';
}

function Loader({ size = 'lg' }: LoaderProps) {
  return (
    <Grid container>
      <Box sx={styles[size]}>
        <CircularProgress size={80} thickness={7} />
      </Box>
    </Grid>
  );
}

export default Loader;
